import {
    AuthenticationProvider,
    ConsentProvider,
    I18nProvider,
    ModalProvider,
    MonitoringErrorBoundary,
    NotificationsChildren,
    NotificationsProvider,
} from '@freelancelabs/components/index';
import { initLocales } from '@freelancelabs/shared/lib/i18n/locales';

import Setup from './Setup';

// @ts-expect-error -- le type de retour d'import.meta.glob ne correspond pas a la signature d'initLocales
initLocales(import.meta.glob('../../locales/*.json'));
const App = () => {
    return (
        <MonitoringErrorBoundary>
            <I18nProvider>
                <ModalProvider>
                    <NotificationsProvider>
                        <AuthenticationProvider
                            awsUserPoolsId={import.meta.env.PUBLIC_AWS_USER_POOLS_ID}
                            awsUserPoolsWebClientId={import.meta.env.PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID}
                            awsCognitoRegion={import.meta.env.PUBLIC_AWS_COGNITO_REGION}
                        >
                            <ConsentProvider>
                                <NotificationsChildren />
                                <Setup />
                            </ConsentProvider>
                        </AuthenticationProvider>
                    </NotificationsProvider>
                </ModalProvider>
            </I18nProvider>
        </MonitoringErrorBoundary>
    );
};

export default App;
